// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-box {
  width: 100%;
  max-width: 480px;
  animation: slideInRight 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  position: relative;
  z-index: 10;
  margin: 0;
  margin-left: auto !important;
  margin-right: 0 !important;
  flex-shrink: 0;
  /* No inner scroller. It used to be \`max-height: 100vh\` inside a panel that
     was itself 100vh minus 80px of padding, so the last ~80px of the card was
     cut off no matter how far you scrolled the box. The page scrolls instead. */
  max-height: none;
  overflow: visible;
  padding-right: 0;
}
.login-box::-webkit-scrollbar {
  width: 6px;
}
.login-box::-webkit-scrollbar-track {
  background: var(--primary-soft);
  border-radius: var(--radius);
}
.login-box::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: var(--radius);
}
@media (max-width: 1024px) {
  .login-box {
    max-width: 100%;
    margin: 0 auto !important;
    max-height: none;
  }
}

.login-card {
  --lf-auth-unit: clamp(5px, 1.1vh, 12px);
  background: var(--card) !important;
  backdrop-filter: blur(24px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(24px) saturate(180%) !important;
  border-radius: 20px;
  border: 1px solid var(--border) !important;
  box-shadow: var(--shadow-lg) !important;
  padding: calc(var(--lf-auth-unit) * 3.2) 36px;
  width: 100%;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}
.login-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--brand-500) 0%, var(--brand-400) 50%, var(--brand-500) 100%);
  background-size: 200% 100%;
  animation: accentLine 4s ease-in-out infinite;
  z-index: 1;
}
.login-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg), var(--shadow-glow);
}
@media (max-width: 576px) {
  .login-card {
    padding: 32px 24px;
    border-radius: 16px;
  }
}

@keyframes accentLine {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}
.login-header {
  text-align: center;
  margin-bottom: calc(var(--lf-auth-unit) * 2.2);
  position: relative;
  z-index: 2;
}
.login-header .logo-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: calc(var(--lf-auth-unit) * 1.6);
  position: relative;
}
.login-header .logo-container .lf-logo {
  --lf-logo-size: clamp(24px, 4vh, 34px);
  animation: logoReveal 0.8s ease-out both;
}
.login-header .logo-container .lf-logo__mark {
  width: var(--lf-logo-size);
  height: var(--lf-logo-size);
  filter: drop-shadow(0 2px 8px rgba(16, 185, 129, 0.2));
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.login-header .logo-container::after {
  content: "";
  position: absolute;
  inset: -8px;
  background: linear-gradient(135deg, transparent 40%, var(--primary-soft) 50%, transparent 60%);
  opacity: 0;
  transform: translateX(-100%);
  transition: all 0.6s ease;
  pointer-events: none;
}
.login-header .logo-container:hover .lf-logo__mark {
  transform: scale(1.06) rotate(-2deg);
}
.login-header .logo-container:hover::after {
  opacity: 1;
  transform: translateX(100%);
}
.login-header .login-title {
  font-size: clamp(1.25rem, 2.6vh, 1.625rem);
  font-weight: 700;
  color: var(--foreground);
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
  animation: fadeInUp 0.5s ease-out 0.2s both;
}
.login-header .login-title::after {
  content: "";
  display: block;
  width: 40px;
  height: 3px;
  margin: calc(var(--lf-auth-unit) * 0.8) auto 0;
  background: linear-gradient(90deg, transparent, var(--brand-500), transparent);
  border-radius: 2px;
}
.login-header .login-description {
  font-size: 0.9375rem;
  color: var(--muted-foreground);
  margin: calc(var(--lf-auth-unit) * 1.2) 0 0 0;
  line-height: 1.5;
  animation: fadeInUp 0.5s ease-out 0.3s both;
}

@keyframes logoReveal {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.login-form {
  width: 100%;
  position: relative;
  z-index: 2;
}
.login-form .form-group {
  margin-bottom: calc(var(--lf-auth-unit) * 1.6);
  width: 100%;
  animation: fadeInUp 0.5s ease-out both;
}
.login-form .form-group--1 {
  animation-delay: 0.35s;
}
.login-form .form-group--2 {
  animation-delay: 0.45s;
}
.login-form .form-group--3 {
  animation-delay: 0.55s;
}
.login-form .form-group--4 {
  animation-delay: 0.65s;
}
.login-form .form-group .form-label {
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--foreground);
  margin-bottom: calc(var(--lf-auth-unit) * 0.6);
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.login-form .form-group .input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.login-form .form-group .input-wrapper .input-icon {
  position: absolute;
  left: 14px;
  width: 18px;
  height: 18px;
  color: var(--muted-foreground);
  z-index: 2;
  transition: all 0.3s ease;
  pointer-events: none;
}
.login-form .form-group .input-wrapper .form-input {
  width: 100%;
  padding: var(--lf-auth-unit) 16px var(--lf-auth-unit) 44px;
  font-size: 0.9375rem;
  color: var(--foreground);
  background: var(--background);
  border: 1.5px solid var(--input);
  border-radius: 10px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  font-family: inherit;
  box-sizing: border-box;
}
.login-form .form-group .input-wrapper .form-input::placeholder {
  color: var(--muted-foreground);
}
.login-form .form-group .input-wrapper .form-input:focus {
  border-color: var(--primary) !important;
  background: var(--card) !important;
  box-shadow: 0 0 0 3px var(--ring) !important;
}
.login-form .form-group .input-wrapper .form-input:focus ~ .input-icon {
  color: var(--primary);
  transform: scale(1.08);
}
.login-form .form-group .input-wrapper .form-input:hover:not(:focus) {
  border-color: var(--border-strong);
  background: var(--card);
}
.login-form .form-options {
  margin-bottom: 20px;
  margin-top: 4px;
}
.login-form .form-options .checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.login-form .form-options .checkbox-label .checkbox-input {
  display: none;
}
.login-form .form-options .checkbox-label .checkbox-input:checked ~ .checkbox-custom {
  background: var(--primary);
  border-color: var(--primary);
}
.login-form .form-options .checkbox-label .checkbox-input:checked ~ .checkbox-custom::after {
  opacity: 1;
  transform: scale(1) rotate(45deg);
}
.login-form .form-options .checkbox-label .checkbox-custom {
  position: relative;
  width: 18px;
  height: 18px;
  border: 2px solid var(--border-strong);
  border-radius: 5px;
  margin-right: 10px;
  transition: all 0.2s ease;
  background: var(--background);
  flex-shrink: 0;
}
.login-form .form-options .checkbox-label .checkbox-custom::after {
  content: "";
  position: absolute;
  top: 1px;
  left: 5px;
  width: 4px;
  height: 8px;
  border: solid var(--primary-foreground);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) scale(0);
  opacity: 0;
  transition: all 0.2s ease;
}
.login-form .form-options .checkbox-label .checkbox-text {
  font-size: 0.875rem;
  color: var(--muted-foreground);
  font-weight: 500;
}
.login-form .form-options .checkbox-label:hover .checkbox-custom {
  border-color: var(--primary);
  background: var(--primary-soft);
}
.login-form .login-button {
  width: 100% !important;
  padding: 14px 24px !important;
  font-size: 0.9375rem !important;
  font-weight: 600 !important;
  color: var(--primary-foreground) !important;
  background: linear-gradient(135deg, var(--brand-500) 0%, var(--brand-600) 100%) !important;
  border: none !important;
  border-radius: 10px !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--shadow-glow);
  position: relative;
  overflow: hidden;
  font-family: inherit;
  box-sizing: border-box;
  margin-top: 4px;
}
.login-form .login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-glow);
  background: linear-gradient(135deg, var(--brand-400) 0%, var(--brand-500) 100%) !important;
}
.login-form .login-button:hover:not(:disabled) .button-icon {
  transform: translateX(4px);
}
.login-form .login-button:active:not(:disabled) {
  transform: translateY(0);
}
.login-form .login-button:disabled {
  cursor: not-allowed;
  opacity: 0.9;
}
.login-form .login-button .button-icon {
  width: 18px;
  height: 18px;
  transition: transform 0.3s ease;
}
.login-form .login-button span {
  position: relative;
  z-index: 1;
}
.login-form .login-button__ripple {
  position: absolute;
  width: 20px;
  height: 20px;
  margin-left: -10px;
  margin-top: -10px;
  background: var(--primary-foreground);
  opacity: 0.5;
  border-radius: var(--radius-full);
  animation: rippleExpand 0.6s ease-out forwards;
  pointer-events: none;
}
@keyframes rippleExpand {
  from {
    transform: scale(1);
    opacity: 0.6;
  }
  to {
    transform: scale(20);
    opacity: 0;
  }
}
.login-form .login-button__spinner {
  width: 22px;
  height: 22px;
  border: 2px solid var(--ring);
  border-top-color: var(--primary-foreground);
  border-radius: var(--radius-full);
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.login-form .login-button--loading .button-icon {
  display: none;
}

.login-footer {
  margin-top: calc(var(--lf-auth-unit) * 1.9);
  padding-top: calc(var(--lf-auth-unit) * 1.6);
  border-top: 1px solid var(--border);
  text-align: center;
  z-index: 2;
  animation: fadeInUp 0.5s ease-out 0.75s both;
}
.login-footer .footer-text {
  font-size: 0.875rem;
  color: var(--muted-foreground);
  margin: 0;
}
.login-footer .footer-link {
  color: var(--primary);
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s ease;
  position: relative;
}
.login-footer .footer-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 1.5px;
  background: var(--primary);
  transition: width 0.2s ease;
}
.login-footer .footer-link:hover {
  color: var(--primary-hover);
}
.login-footer .footer-link:hover::after {
  width: 100%;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/login/components/MainSection.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,gBAAA;EACA,mEAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,4BAAA;EACA,0BAAA;EACA,cAAA;EACA;;gFAAA;EAGA,gBAAA;EACA,iBAAA;EACA,gBAAA;AADF;AAGE;EAAuB,UAAA;AAAzB;AACE;EAA6B,+BAAA;EAAiC,4BAAA;AAGhE;AAFE;EAA6B,kCAAA;EAAoC,4BAAA;AAMnE;AAJE;EArBF;IAsBI,eAAA;IACA,yBAAA;IACA,gBAAA;EAOF;AACF;;AAGA;EAME,uCAAA;EAEA,kCAAA;EACA,qDAAA;EACA,6DAAA;EACA,mBAAA;EACA,0CAAA;EACA,uCAAA;EACA,6CAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,sBAAA;AANF;AAQE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oGAAA;EACA,0BAAA;EACA,6CAAA;EACA,UAAA;AANJ;AASE;EACE,2BAAA;EACA,gDAAA;AAPJ;AAUE;EAvCF;IAwCI,kBAAA;IACA,mBAAA;EAPF;AACF;;AAUA;EACE;IAAW,2BAAA;EANX;EAOA;IAAM,6BAAA;EAJN;AACF;AAOA;EACE,kBAAA;EACA,8CAAA;EACA,kBAAA;EACA,UAAA;AALF;AAOE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,kBAAA;AALJ;AAUI;EACE,sCAAA;EACA,wCAAA;AARN;AAWI;EACE,0BAAA;EACA,2BAAA;EACA,sDAAA;EACA,4DAAA;AATN;AAYI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,8FAAA;EACA,UAAA;EACA,4BAAA;EACA,yBAAA;EACA,oBAAA;AAVN;AAaI;EACE,oCAAA;AAXN;AAcI;EACE,UAAA;EACA,2BAAA;AAZN;AAgBE;EACE,0CAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;EACA,sBAAA;EACA,2CAAA;AAdJ;AAgBI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,8CAAA;EACA,8EAAA;EACA,kBAAA;AAdN;AAkBE;EACE,oBAAA;EACA,8BAAA;EACA,6CAAA;EACA,gBAAA;EACA,2CAAA;AAhBJ;;AAoBA;EACE;IACE,UAAA;IACA,uCAAA;EAjBF;EAmBA;IACE,UAAA;IACA,iCAAA;EAjBF;AACF;AAoBA;EACE;IACE,UAAA;IACA,2BAAA;EAlBF;EAoBA;IACE,UAAA;IACA,wBAAA;EAlBF;AACF;AAsBA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;AApBF;AAsBE;EACE,8CAAA;EACA,WAAA;EACA,sCAAA;AApBJ;AAsBI;EAAO,sBAAA;AAnBX;AAoBI;EAAO,sBAAA;AAjBX;AAkBI;EAAO,sBAAA;AAfX;AAgBI;EAAO,sBAAA;AAbX;AAeI;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,wBAAA;EACA,8CAAA;EACA,qBAAA;EACA,yBAAA;AAbN;AAgBI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAdN;AAgBM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;AAdR;AAiBM;EACE,WAAA;EACA,0DAAA;EACA,oBAAA;EACA,wBAAA;EACA,6BAAA;EACA,gCAAA;EACA,mBAAA;EACA,kDAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;AAfR;AAiBQ;EAAiB,8BAAA;AAdzB;AAgBQ;EACE,uCAAA;EACA,kCAAA;EACA,4CAAA;AAdV;AAgBU;EACE,qBAAA;EACA,sBAAA;AAdZ;AAkBQ;EACE,kCAAA;EACA,uBAAA;AAhBV;AAsBE;EACE,mBAAA;EACA,eAAA;AApBJ;AAsBI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AApBN;AAsBM;EACE,aAAA;AApBR;AAsBQ;EACE,0BAAA;EACA,4BAAA;AApBV;AAsBU;EACE,UAAA;EACA,iCAAA;AApBZ;AAyBM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,cAAA;AAvBR;AAyBQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,uCAAA;EACA,yBAAA;EACA,iCAAA;EACA,UAAA;EACA,yBAAA;AAvBV;AA2BM;EACE,mBAAA;EACA,8BAAA;EACA,gBAAA;AAzBR;AA4BM;EACE,4BAAA;EACA,+BAAA;AA1BR;AAgCE;EACE,sBAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,2CAAA;EACA,0FAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iDAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,eAAA;AA9BJ;AAgCI;EACE,2BAAA;EACA,8BAAA;EACA,0FAAA;AA9BN;AAgCM;EACE,0BAAA;AA9BR;AAkCI;EACE,wBAAA;AAhCN;AAmCI;EACE,mBAAA;EACA,YAAA;AAjCN;AAoCI;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AAlCN;AAqCI;EAAO,kBAAA;EAAoB,UAAA;AAjC/B;AAqCE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,YAAA;EACA,iCAAA;EACA,8CAAA;EACA,oBAAA;AAnCJ;AAsCE;EACE;IACE,mBAAA;IACA,YAAA;EApCJ;EAsCE;IACE,oBAAA;IACA,UAAA;EApCJ;AACF;AAwCE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,2CAAA;EACA,iCAAA;EACA,oCAAA;AAtCJ;AAyCE;EACE;IAAK,yBAAA;EAtCP;AACF;AAwCE;EACE,aAAA;AAtCJ;;AA2CA;EACE,2CAAA;EACA,4CAAA;EACA,mCAAA;EACA,kBAAA;EACA,UAAA;EACA,4CAAA;AAxCF;AA0CE;EACE,mBAAA;EACA,8BAAA;EACA,SAAA;AAxCJ;AA2CE;EACE,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAzCJ;AA2CI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,0BAAA;EACA,2BAAA;AAzCN;AA4CI;EACE,2BAAA;AA1CN;AA4CM;EAAW,WAAA;AAzCjB;;AA8CA;EACE;IACE,UAAA;IACA,2BAAA;EA3CF;EA6CA;IACE,UAAA;IACA,wBAAA;EA3CF;AACF","sourcesContent":["// MainSection - Professional Login Form with animations\n\n.login-box {\n  width: 100%;\n  max-width: 480px;\n  animation: slideInRight 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n  position: relative;\n  z-index: 10;\n  margin: 0;\n  margin-left: auto !important;\n  margin-right: 0 !important;\n  flex-shrink: 0;\n  /* No inner scroller. It used to be `max-height: 100vh` inside a panel that\n     was itself 100vh minus 80px of padding, so the last ~80px of the card was\n     cut off no matter how far you scrolled the box. The page scrolls instead. */\n  max-height: none;\n  overflow: visible;\n  padding-right: 0;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-track { background: var(--primary-soft); border-radius: var(--radius); }\n  &::-webkit-scrollbar-thumb { background: var(--scrollbar-thumb); border-radius: var(--radius); }\n\n  @media (max-width: 1024px) {\n    max-width: 100%;\n    margin: 0 auto !important;\n    max-height: none;\n  }\n}\n\n// The card's vertical rhythm is a function of the VIEWPORT HEIGHT, not a step\n// at one breakpoint. A 1366x768 laptop leaves ~680px of viewport and a 1280x720\n// one ~630px, and at fixed spacing this card is ~690px tall — so both put a\n// scrollbar on a screen that should have fit it. Every vertical value below is\n// `clamp(floor, Nvh, design value)`: full size on a roomy screen, smoothly\n// tighter as the window shortens, never below the floor. Side padding and font\n// sizes that carry meaning stay fixed.\n.login-card {\n  // ONE spacing unit for the whole card, driven by the viewport height; every\n  // vertical value below is a multiple of it, so the card keeps its proportions\n  // as it tightens instead of nine clamps drifting apart. Sign-up is the tall\n  // case (four fields): at a 633px viewport this lands it just inside the\n  // screen, and below ~620px the page scrolls, which is the honest outcome.\n  --lf-auth-unit: clamp(5px, 1.1vh, 12px);\n\n  background: var(--card) !important;\n  backdrop-filter: blur(24px) saturate(180%) !important;\n  -webkit-backdrop-filter: blur(24px) saturate(180%) !important;\n  border-radius: 20px;\n  border: 1px solid var(--border) !important;\n  box-shadow: var(--shadow-lg) !important;\n  padding: calc(var(--lf-auth-unit) * 3.2) 36px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  box-sizing: border-box;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, var(--brand-500) 0%, var(--brand-400) 50%, var(--brand-500) 100%);\n    background-size: 200% 100%;\n    animation: accentLine 4s ease-in-out infinite;\n    z-index: 1;\n  }\n\n  &:hover {\n    transform: translateY(-3px);\n    box-shadow: var(--shadow-lg), var(--shadow-glow);\n  }\n\n  @media (max-width: 576px) {\n    padding: 32px 24px;\n    border-radius: 16px;\n  }\n}\n\n@keyframes accentLine {\n  0%, 100% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n}\n\n// Header with logo shine\n.login-header {\n  text-align: center;\n  margin-bottom: calc(var(--lf-auth-unit) * 2.2);\n  position: relative;\n  z-index: 2;\n\n  .logo-container {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: calc(var(--lf-auth-unit) * 1.6);\n    position: relative;\n\n    // The logo is a component now (components/Atoms/Logo.jsx), not an <img>.\n    // `--lf-logo-size` drives both halves of the lockup, so one fluid value\n    // keeps it in step with the card's own viewport-height rhythm.\n    .lf-logo {\n      --lf-logo-size: clamp(24px, 4vh, 34px);\n      animation: logoReveal 0.8s ease-out both;\n    }\n\n    .lf-logo__mark {\n      width: var(--lf-logo-size);\n      height: var(--lf-logo-size);\n      filter: drop-shadow(0 2px 8px rgba(16, 185, 129, 0.2));\n      transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      inset: -8px;\n      background: linear-gradient(135deg, transparent 40%, var(--primary-soft) 50%, transparent 60%);\n      opacity: 0;\n      transform: translateX(-100%);\n      transition: all 0.6s ease;\n      pointer-events: none;\n    }\n\n    &:hover .lf-logo__mark {\n      transform: scale(1.06) rotate(-2deg);\n    }\n\n    &:hover::after {\n      opacity: 1;\n      transform: translateX(100%);\n    }\n  }\n\n  .login-title {\n    font-size: clamp(1.25rem, 2.6vh, 1.625rem);\n    font-weight: 700;\n    color: var(--foreground);\n    margin: 0 0 8px 0;\n    letter-spacing: -0.5px;\n    animation: fadeInUp 0.5s ease-out 0.2s both;\n\n    &::after {\n      content: '';\n      display: block;\n      width: 40px;\n      height: 3px;\n      margin: calc(var(--lf-auth-unit) * 0.8) auto 0;\n      background: linear-gradient(90deg, transparent, var(--brand-500), transparent);\n      border-radius: 2px;\n    }\n  }\n\n  .login-description {\n    font-size: 0.9375rem;\n    color: var(--muted-foreground);\n    margin: calc(var(--lf-auth-unit) * 1.2) 0 0 0;\n    line-height: 1.5;\n    animation: fadeInUp 0.5s ease-out 0.3s both;\n  }\n}\n\n@keyframes logoReveal {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Form with staggered animations\n.login-form {\n  width: 100%;\n  position: relative;\n  z-index: 2;\n\n  .form-group {\n    margin-bottom: calc(var(--lf-auth-unit) * 1.6);\n    width: 100%;\n    animation: fadeInUp 0.5s ease-out both;\n\n    &--1 { animation-delay: 0.35s; }\n    &--2 { animation-delay: 0.45s; }\n    &--3 { animation-delay: 0.55s; }\n    &--4 { animation-delay: 0.65s; }\n\n    .form-label {\n      display: block;\n      font-size: 0.8125rem;\n      font-weight: 600;\n      color: var(--foreground);\n      margin-bottom: calc(var(--lf-auth-unit) * 0.6);\n      letter-spacing: 0.3px;\n      text-transform: uppercase;\n    }\n\n    .input-wrapper {\n      position: relative;\n      display: flex;\n      align-items: center;\n\n      .input-icon {\n        position: absolute;\n        left: 14px;\n        width: 18px;\n        height: 18px;\n        color: var(--muted-foreground);\n        z-index: 2;\n        transition: all 0.3s ease;\n        pointer-events: none;\n      }\n\n      .form-input {\n        width: 100%;\n        padding: var(--lf-auth-unit) 16px var(--lf-auth-unit) 44px;\n        font-size: 0.9375rem;\n        color: var(--foreground);\n        background: var(--background);\n        border: 1.5px solid var(--input);\n        border-radius: 10px;\n        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n        outline: none;\n        font-family: inherit;\n        box-sizing: border-box;\n\n        &::placeholder { color: var(--muted-foreground); }\n\n        &:focus {\n          border-color: var(--primary) !important;\n          background: var(--card) !important;\n          box-shadow: 0 0 0 3px var(--ring) !important;\n\n          ~ .input-icon {\n            color: var(--primary);\n            transform: scale(1.08);\n          }\n        }\n\n        &:hover:not(:focus) {\n          border-color: var(--border-strong);\n          background: var(--card);\n        }\n      }\n    }\n  }\n\n  .form-options {\n    margin-bottom: 20px;\n    margin-top: 4px;\n\n    .checkbox-label {\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      user-select: none;\n\n      .checkbox-input {\n        display: none;\n\n        &:checked ~ .checkbox-custom {\n          background: var(--primary);\n          border-color: var(--primary);\n\n          &::after {\n            opacity: 1;\n            transform: scale(1) rotate(45deg);\n          }\n        }\n      }\n\n      .checkbox-custom {\n        position: relative;\n        width: 18px;\n        height: 18px;\n        border: 2px solid var(--border-strong);\n        border-radius: 5px;\n        margin-right: 10px;\n        transition: all 0.2s ease;\n        background: var(--background);\n        flex-shrink: 0;\n\n        &::after {\n          content: '';\n          position: absolute;\n          top: 1px;\n          left: 5px;\n          width: 4px;\n          height: 8px;\n          border: solid var(--primary-foreground);\n          border-width: 0 2px 2px 0;\n          transform: rotate(45deg) scale(0);\n          opacity: 0;\n          transition: all 0.2s ease;\n        }\n      }\n\n      .checkbox-text {\n        font-size: 0.875rem;\n        color: var(--muted-foreground);\n        font-weight: 500;\n      }\n\n      &:hover .checkbox-custom {\n        border-color: var(--primary);\n        background: var(--primary-soft);\n      }\n    }\n  }\n\n  // Button with ripple and loading\n  .login-button {\n    width: 100% !important;\n    padding: 14px 24px !important;\n    font-size: 0.9375rem !important;\n    font-weight: 600 !important;\n    color: var(--primary-foreground) !important;\n    background: linear-gradient(135deg, var(--brand-500) 0%, var(--brand-600) 100%) !important;\n    border: none !important;\n    border-radius: 10px !important;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: var(--shadow-glow);\n    position: relative;\n    overflow: hidden;\n    font-family: inherit;\n    box-sizing: border-box;\n    margin-top: 4px;\n\n    &:hover:not(:disabled) {\n      transform: translateY(-2px);\n      box-shadow: var(--shadow-glow);\n      background: linear-gradient(135deg, var(--brand-400) 0%, var(--brand-500) 100%) !important;\n\n      .button-icon {\n        transform: translateX(4px);\n      }\n    }\n\n    &:active:not(:disabled) {\n      transform: translateY(0);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.9;\n    }\n\n    .button-icon {\n      width: 18px;\n      height: 18px;\n      transition: transform 0.3s ease;\n    }\n\n    span { position: relative; z-index: 1; }\n  }\n\n  // Ripple effect\n  .login-button__ripple {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    margin-left: -10px;\n    margin-top: -10px;\n    background: var(--primary-foreground);\n    opacity: 0.5;\n    border-radius: var(--radius-full);\n    animation: rippleExpand 0.6s ease-out forwards;\n    pointer-events: none;\n  }\n\n  @keyframes rippleExpand {\n    from {\n      transform: scale(1);\n      opacity: 0.6;\n    }\n    to {\n      transform: scale(20);\n      opacity: 0;\n    }\n  }\n\n  // Loading spinner\n  .login-button__spinner {\n    width: 22px;\n    height: 22px;\n    border: 2px solid var(--ring);\n    border-top-color: var(--primary-foreground);\n    border-radius: var(--radius-full);\n    animation: spin 0.8s linear infinite;\n  }\n\n  @keyframes spin {\n    to { transform: rotate(360deg); }\n  }\n\n  .login-button--loading .button-icon {\n    display: none;\n  }\n}\n\n// Footer\n.login-footer {\n  margin-top: calc(var(--lf-auth-unit) * 1.9);\n  padding-top: calc(var(--lf-auth-unit) * 1.6);\n  border-top: 1px solid var(--border);\n  text-align: center;\n  z-index: 2;\n  animation: fadeInUp 0.5s ease-out 0.75s both;\n\n  .footer-text {\n    font-size: 0.875rem;\n    color: var(--muted-foreground);\n    margin: 0;\n  }\n\n  .footer-link {\n    color: var(--primary);\n    text-decoration: none;\n    font-weight: 600;\n    transition: all 0.2s ease;\n    position: relative;\n\n    &::after {\n      content: '';\n      position: absolute;\n      bottom: -2px;\n      left: 0;\n      width: 0;\n      height: 1.5px;\n      background: var(--primary);\n      transition: width 0.2s ease;\n    }\n\n    &:hover {\n      color: var(--primary-hover);\n\n      &::after { width: 100%; }\n    }\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
